export var validateDepositTicketPayload = function validateDepositTicketPayload(payload,
/**
 * "registeredFields" is supplied by redux-form.
 * It contains all <Field /> components mounted as children of the form.
 */
registeredFields) {
  return Object.keys(payload).reduce(function (acc, key) {
    if (registeredFields.hasOwnProperty(key) || key === 'ProductSymbol' || key === 'ProductId') acc[key] = payload[key];
    return acc;
  }, {});
};